/**
 * Is this a route the agent may send us to?
 *
 * The agent hands the frontend resolved routes rather than ids: helpdesk article links
 * arrive both as an `open_help_article` action and as the url on a help citation. Our own
 * backend builds them, but they still cross a trust boundary on the way to the router, so
 * both entry points have to refuse anything that could leave the app.
 *
 * Shared rather than written twice. Two copies of an open-redirect check drift the moment
 * one of them is hardened — against `/\evil.com`, say, which some browsers normalise to a
 * protocol-relative URL — and the copy that was missed is the one still shipping.
 *
 * Rejects: absolute URLs, protocol-relative `//host`, backslash variants, and anything
 * that is not a path.
 */
export function isSafeInAppRoute(route: string | undefined | null): route is string {
  if (!route) return false
  // Normalise backslashes first: a browser may read `/\host` or `\\host` as
  // protocol-relative, so checking the raw string alone would let those through.
  const normalised = route.replace(/\\/g, "/")
  if (!normalised.startsWith("/")) return false
  if (normalised.startsWith("//")) return false
  return true
}
